import { ListItemIcon, MenuItem } from "@material-ui/core";
import { get } from "lodash";
import React, { Fragment, useState } from "react";
import {
	Button,
	Confirm,
	useCreate,
	useNotify,
	useTranslate,
} from "react-admin";
import { BookmakerChannelIcon } from "../icons";

const CreateChannelsButton = ({
	record,
	isButton = false,
	basePath,
	...props
}) => {
	const id = get(record, "id");
	const name = get(record, "name");
	const channelsToCreate = get(record, "sync_channels_to_create", 100);
	const translate = useTranslate();
	const notify = useNotify();
	const [open, setOpen] = useState(false);
	const handleClick = () => setOpen(true);
	const handleDialogClose = () => setOpen(false);
	const command = {
		name: "channel",
		args: ["creator", id],
		notify_args: {
			title: translate("bookmakers.actions.create_channels.notify_title", {
				name,
			}),
			content: translate("bookmakers.actions.create_channels.notify_content"),
			resource: "bookmakers",
		},
	};
	const [create, { loading }] = useCreate("commands", command, {
		onSuccess: () => {
			notify("bookmakers.actions.create_channels.success");
		},
	});
	const handleConfirm = () => {
		create();
		setOpen(false);
	};
	const label = translate("bookmakers.actions.create_channels");
	return (
		<Fragment>
			{isButton ? (
				<Button
					disabled={loading}
					color="secondary"
					label={label}
					onClick={handleClick}
					{...props}
				>
					<BookmakerChannelIcon />
				</Button>
			) : (
				<MenuItem onClick={handleClick}>
					<ListItemIcon>
						<BookmakerChannelIcon size="small" />
					</ListItemIcon>
					{label}
				</MenuItem>
			)}
			<Confirm
				isOpen={open}
				loading={loading}
				title={translate("bookmakers.actions.create_channels.title")}
				content={translate("bookmakers.actions.create_channels.content", {
					channels_to_create: channelsToCreate,
				})}
				onConfirm={handleConfirm}
				onClose={handleDialogClose}
			/>
		</Fragment>
	);
};

export default CreateChannelsButton;
